import React from 'react'
import { Link, useParams } from 'react-router-dom';
import { Typography, Card, CardContent, CardMedia } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import { demoThumbnailUrl, demoVideoUrl, demoVideoTitle, demoChannelUrl, demoChannelTitle } from '../utils/constants'


const VideoCard = ({video : {id : {videoId}, snippet, statistics }}) => {
    // const [views, setViews] = React.useState([])
    // const {id} = useParams();
    // console.log(views);
    // React.useEffect(() => {
    //     fatchFromApi(`videos?part=snippet,statistics&id=${id}`).then((data) => setViews(data.items[0]))
    //   },[id])
    return (
    <Card sx={{width:{ xs: '100%', sm: '358px', md:'320px'}}}>
        <Link to={videoId? `/video/${videoId}` : demoVideoUrl}>
            <CardMedia 
            image={snippet?.thumbnails?.high?.url}
            alt={snippet?.title}
            sx={{width: {xs: '100%', sm:'358px', md: '320px'}, height: 180}} />
        </Link>
        <CardContent sx={{backgroundColor:'#1e1e1e', height:'106px'}}>
        <Link to={videoId? `/video/${videoId}` : demoVideoUrl}>
            <Typography variant='subtitle1' sx={{color:'#fff', fontWeight:'bold'}}>
                {snippet?.title.slice(0,60) || demoVideoTitle.slice(0,60)}
            </Typography>
        </Link>
        <Link to={snippet?.channelId ?`/channel/${snippet?.channelId}` : demoChannelUrl}>
            <Typography variant='subtitle4' sx={{color:'gray', fontWeight:'bold'}}>
                {snippet?.channelTitle.slice(0,60) || demoChannelTitle.slice(0,60)}
            </Typography>
            <CheckCircleIcon sx={{color:'gray', fontSize:'12px', marginLeft:'5px'}}/>
        </Link>
        {/* <Typography sx={{color:'#fff', fontWeight:'bold'}}>
                {parseInt(views?.statistics?.viewCount).toLocaleString()}
            </Typography> */}
        </CardContent>
    </Card>
  )
}

export default VideoCard